import { render, staticRenderFns } from "./customerImg.vue?vue&type=template&id=ec23911e&"
import script from "./customerImg.vue?vue&type=script&lang=js&"
export * from "./customerImg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports